import Collapse02 from './Collapse02';
export default Collapse02;
